import { NgModule } from '@angular/core';
import { SharedModule } from '../shared';
import { PmAccountComponent } from './pm-account/pm-account.component';
import { UiInsurablesComponent } from './ui-insurables/ui-insurables.component';
import { UiUnitComponent } from './ui-insurables/ui-unit/ui-unit.component';
import { UiBuildingComponent } from './ui-insurables/ui-building/ui-building.component';
import { UiCommunityComponent } from './ui-insurables/ui-community/ui-community.component';
import { UiAddressComponent } from './ui-insurables/ui-address/ui-address.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { UiBuildingAddressComponent } from './ui-insurables/ui-building-address/ui-building-address.component';
import { UiAddressSmartyComponent } from './ui-insurables/ui-address-smarty/ui-address-smarty.component';
import { UiSingleHouseAddressComponent } from './ui-single-house-address/ui-single-house-address.component';



@NgModule({
  declarations: [
    PmAccountComponent,
    UiInsurablesComponent,
    UiUnitComponent,
    UiBuildingComponent,
    UiCommunityComponent,
    UiAddressComponent,
    UiAddressSmartyComponent,
    UiBuildingAddressComponent,
    UiSingleHouseAddressComponent
  ],
  imports: [
    SharedModule,
    TranslateModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    GooglePlaceModule,
  ],
  exports: [
    PmAccountComponent,
    UiInsurablesComponent,
    UiAddressComponent,
    UiAddressSmartyComponent
  ]
})
export class UIModule { }
